import React from "react";

interface TableFooterProps {
  total?: { title: string; value: React.ReactNode };
  hasAction: boolean;
  columnCount: number;
}

export const TableFooter = ({ total, columnCount, hasAction }: TableFooterProps) => {
  if (!total) return;

  return (
    <tfoot>
      <tr>
        <td>{total.title}</td>
        <td colSpan={columnCount - 1} align="right">
          {total.value}
        </td>
        {hasAction && <td />}
      </tr>
    </tfoot>
  );
};
